<template>
  <div>
    <label>
      <strong>{{ $tc('word.organisation', 1) }}</strong>
    </label>

    <div class="mb-2" v-if="selected">
      {{ selected.name }}
      <v-button
        :icon="selectMode ? 'times' : 'edit'"
        style-type="link"
        size="xs"
        @click="selectMode = !selectMode"
      />
    </div>

    <v-collapse-transition>
      <div v-if="selectMode" class="organisation-container">
        <v-text-input
          id="organisation-select-search"
          placeholder="word.search"
          v-model="organisationSearch"
        />
        <div
          style="max-height: 200px; overflow: auto"
        >
          <div
            v-for="organisation in filteredOrganisations"
            :key="organisation.uuid"
            :class="getOrganisationClass(organisation.id)"
            class="organisation-item"
            @click="selectOrganisation(organisation)"
          >
            <i
              class="fa mr-2"
              :class="getOrganisationIcon(organisation.id)"
            ></i>
            {{ organisation.name }}
          </div>
        </div>
      </div>
    </v-collapse-transition>
  </div>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';
import Button from '@/common/components/Button.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { fetchOrganisations } from '@/admin/api';

export default {
  name: 'OrganisationSelect',
  components: {
    'v-text-input': TextInput,
    'v-button': Button,
    'v-collapse-transition': CollapseTransition,
  },
  props: {
    organisationIdSelected: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      organisations: [],
      selected: null,
      selectMode: false,
      organisationSearch: '',
    };
  },
  computed: {
    filteredOrganisations() {
      return this.organisations.filter((organisation) => (
        organisation.name.toLowerCase()
          .includes(this.organisationSearch.toLowerCase())));
    },
  },
  methods: {
    selectOrganisation(organisation) {
      this.selected = organisation;
      this.$emit('input', organisation.id);
      this.selectMode = false;
    },
    async fetchOrganisations() {
      const response = await fetchOrganisations(this.researchUuid);
      this.organisations = response.data;
      this.selected = this.organisations.find(
        (org) => org.id === this.organisationIdSelected,
      );
    },
    getOrganisationIcon(orgId) {
      if (orgId === this.selected.id) {
        return ['fa-circle-dot'];
      }
      return ['fa-circle'];
    },
    getOrganisationClass(orgId) {
      if (orgId === this.selected.id) {
        return ['text-bold'];
      }
      return [];
    },
  },
  created() {
    this.fetchOrganisations();
  },
};
</script>

<style scoped>
.organisation-container {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  padding: 5px;
}

.organisation-item {
  cursor: pointer;
  padding: 5px;
}

.organisation-item:hover {
  background-color: #f0f0f0;
}
</style>
